import { graphql } from "react-relay";
import { EventSchedulerRoomInput } from "./EventSchedulerRoomInput";

export const query = graphql`
  query EventSchedulerRoomInputRendererQuery($orgRelayId: ID!, $query: SchedulingQueryInput!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        schedulingResponseErrorable(query: $query) {
          ...EventSchedulerRoomInput_schedulingResponseErrorable
        }
        workingGroups(first: 1000000) {
          edges {
            node {
              id
              ...EventSchedulerRoomInput_workingGroup
            }
          }
        }
      }
    }
  }
`;
